import type { ShortlistCandidate } from '@nest-recruit/shared';

// F24.05 "Move to contact": the server goes ahead only for people still waiting for the
// manager (`manager_response = awaiting`, 03-reference §L25, 02-decisions §L31 O30). The button
// follows the same rule, so it is never offered for a press the server would refuse (#48).

export const SEND_FIRST_HINT = 'Send the shortlist to the managers first';
export const ONLY_WAITING_HINT = "Only people waiting for the manager's answer can move to contact";
/** ADR 0079: with phone Screening on, going ahead lands them in Screening, so the hint says so. */
export const ONLY_WAITING_SCREENING_HINT = "Only people waiting for the manager's answer can move to screening";

export function isWaitingForManager(candidate: ShortlistCandidate): boolean {
  return candidate.answer === 'awaiting';
}

/** ADR 0082: with "Shortlist to the line manager" off, someone on the shortlist and never sent moves on too. */
export const NOT_MOVED_HINT = 'Only people who have not moved on yet can move to contact';
export const NOT_MOVED_SCREENING_HINT = 'Only people who have not moved on yet can move to screening';

/** Whether "Move to contact" takes this person: waiting for the manager, or (manager step off) never sent. */
export function mayGoOn(candidate: ShortlistCandidate, isManagerStepOn = true): boolean {
  return isWaitingForManager(candidate) || (!isManagerStepOn && candidate.answer === 'not_sent');
}

/**
 * ADR 0047 "Send test" from ⑤ Shortlist: anyone not yet answered — not sent, or waiting for the
 * manager. A Yes or HR's go-ahead is at Contact already; a No waits to be rejected (§L31).
 */
export function maySendTestFromShortlist(candidate: ShortlistCandidate): boolean {
  return candidate.answer === 'not_sent' || candidate.answer === 'awaiting';
}

/** Why "Move to contact" is off for this selection, or null when someone in it can go ahead. */
export function proceedHint(selected: readonly ShortlistCandidate[], isScreeningOn = false, isManagerStepOn = true): string | null {
  if (selected.some((candidate) => mayGoOn(candidate, isManagerStepOn))) return null;
  if (!isManagerStepOn) return isScreeningOn ? NOT_MOVED_SCREENING_HINT : NOT_MOVED_HINT;
  if (selected.some((candidate) => candidate.answer === 'not_sent')) return SEND_FIRST_HINT;
  return isScreeningOn ? ONLY_WAITING_SCREENING_HINT : ONLY_WAITING_HINT;
}
